import { render, staticRenderFns } from "./MovimientoProductos.vue?vue&type=template&id=0d4d55c9&scoped=true&"
import script from "./MovimientoProductos.vue?vue&type=script&scoped=true&lang=js&"
export * from "./MovimientoProductos.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./MovimientoProductos.vue?vue&type=style&index=0&id=0d4d55c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d55c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VChip,VCol,VDataTable,VIcon,VRow,VSelect,VSnackbar,VTextField})
